import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Login.css";

function Login() {
   const [username, setUsername] = useState("");
   const [password, setPassword] = useState("");
   const navigate = useNavigate();

   const data = {
      email: username,
      password: password,
   };

   const handleLogin = async (e) => {
      e.preventDefault();

      try {
         const response = await axios.post(
            "https://aroma-api-9y1b.onrender.com/login/",
            data
         );

         const token = response.data.token;
         localStorage.setItem("token", token);

         navigate("/upload");
      } catch (error) {
         console.error("Error de inicio de sesión", error);
      }
   };

   return (
      <div className="p-5 container">
         <meta name="robots" content="noindex" />
         <div className="d-flex align-items-center mb-3 mx-4">
            <img src={logo} height={60} />
            <div className="ms-3">
               <h6>Aroma-Tune By Innosol, Inc.</h6>
               <h6></h6>
            </div>
            <p className="py-4 me-0 ms-auto text-end">
               CREATE BEST SELLING PERFUMES, FRAGRANCES & FLAVORS,
               <br />
               INHOUSE & ON-DEMAND
            </p>
         </div>
         <div className="w-50 login--container mx-auto">
            <div className="d-flex align-items-center flex-column w-100 mx-auto px-5">
               <h1 className="mt-4 fw-bold">Login</h1>
               <form
                  onSubmit={handleLogin}
                  className="w-100 d-flex flex-column"
               >
                  <div>
                     <label htmlFor="username" className="my-2">
                        E-mail
                     </label>
                     <br />
                     <input
                        type="email"
                        placeholder="Enter email"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="w-100 px-3"
                        name="username"
                        id="username"
                     />
                  </div>
                  <div>
                     <label htmlFor="password" className="my-2">
                        Password
                     </label>
                     <br />
                     <input
                        type="password"
                        placeholder="Enter password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-100 px-3"
                        name="password"
                        id="password"
                     />
                  </div>
                  <button
                     type="submit"
                     className="mt-4 mb-5 login--btn fw-bold w-100"
                  >
                     Login
                  </button>
               </form>
            </div>
         </div>
      </div>
   );
}

export default Login;
